// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"79":"fc7f3a4b","82":"def7bcef","226":"49e62f9c","351":"b87e1385","477":"108ddac6","547":"c60364e9","607":"fd1ca4f1","787":"ea386385","852":"24644030","858":"ebd83756","885":"ad990763"}[chunkId] + ".js";
};